import { channelRenderHelper, formatFilterTime } from '../renderHelper';
import { DownloadConfigInfoType } from '../types';

export const KeywordAndURLAnalysisUrlChart: DownloadConfigInfoType = {
  columns: ({ auxiliaryParams }) => {
    const { dateType, title } = auxiliaryParams;

    const renderTime = formatFilterTime({ date_type: dateType });

    const tableColumns: any = [
      {
        key: 'time',
        header: 'Date',
        fixed: 'left',
        renderHelper: [renderTime],
      },
      {
        key: 'key',
        header: 'Channel',
        fixed: 'left',
        renderHelper: [channelRenderHelper],
      },
      {
        key: 'value',
        header: title,
        fixed: 'left',
      },
    ];

    return tableColumns;
  },
};
